module.exports = __webpack_public_path__ + "static/media/bg-step-future-1.8a126f18.png";